const messages: Record<string, string> = {
	'blockedByDevice.headline': 'Használjon okostelefont!',
	'blockedByDevice.paragraph.first': 'Ez a link kizárólag okostelefonon használható.',
	'blockedByDevice.paragraph.second':
		'Hasznos tipp: a link megnyitásakor legyen a jármű közelében és készítse elő a szükséges dokumentumokat.',
	'button.continue': 'Tovább',
	'button.next': 'Tovább',
	'review.button.next': 'Befejezés',
	'button.photo.take': 'Fénykép készítése',
	'onboardingStart.headline': 'Üdvözöljük! Kérjük, ellenőrizze adatait a folytatáshoz.',
	'onboardingStart.plateNumber': 'Szerződésazonosító:',
	'onboardingStart.damageNumber': 'Kötvényszám:',
	'onboardingStart.timeout': 'A link érvényességi ideje ',
	'button.start': 'Start',
	poweredBy: 'Powered by <ce>ControlExpert</ce>, a <solvd>Solvd</solvd> group company',
	'onboarding.headline': 'Digitális szemle indítása',
	'onboarding.paragraph': 'A folyamat megkezdése előtt kérjük, vegye figyelembe az alábbiakat:',
	'onboarding.documents': "Have the keys and the vehicle's registration card available.",
	'onboarding.camera': 'A fényképeket kizárólag okostelefon kamerájával tudja elkészíteni.',
	'onboarding.internet':
		'Tartózkodjon jól megvilágított helyen, és gondoskodjon stabil internetkapcsolatról.',
	'onboarding.vehicle':
		'Győződjön meg arról, hogy a jármű tiszta, minden oldalról jól látható, és az összes ablak fel van húzva.',
	'onboarding.terms.before': 'A folyamat megkezdése előtt kérjük, erősítse meg az alábbiakat:',
	'onboarding.terms.url': 'Elfogadom az Általános Szerződési Feltételeket.',
	'vehicleFrontLeftPerspectiveImage.title': 'A gépjármű bal első része átlósan.',
	'vehicleFrontLeftPerspectiveImage.description':
		'Fotózza le az autót a bal első oldala felől! A teljes jármű és a rendszám is legyen látható a képen.',
	'vehicleRearLeftPerspectiveImage.title': 'A gépjármű bal hátsó első része átlósan',
	'vehicleRearLeftPerspectiveImage.description':
		'Fotózza le az autót a bal hátsó oldala felől! A teljes jármű és a rendszám is legyen látható a képen.',
	'vehicleRearRightPerspectiveImage.title': 'A gépjármű hátsó jobb része átlósan',
	'vehicleRearRightPerspectiveImage.description':
		'Fotózza le az autót a jobb hátsó oldala felől! A teljes jármű és a rendszám is legyen látható a képen.',
	'vehicleFrontRightPerspectiveImage.title': 'A gépjármű jobb első része átlósan',
	'vehicleFrontRightPerspectiveImage.description':
		'Fotózza le az autót a jobb első oldala felől! A teljes jármű és a rendszám is legyen látható a képen.',
	'windshieldImage.title': 'Szélvédő',
	'windshieldImage.description':
		'Készítsen fényképet a szélvédőről úgy, hogy a teljes üvegfelület és annak minden részlete jól látható legyen.',
	'vinPicture.title': 'Alvázszám',
	'vinPicture.description':
		'Készítsen fotót a gépjármű alvázszámáról ügyelve arra, hogy minden karakter látszódjon.',
	'button.hint': 'Hol található a jármű alvázszáma?',
	'hint.vin.title': ' ',
	'hint.vin.description': 'Az alvázszámot jellemzően az alábbi helyeken találhatja meg:',
	'hint.vin.location1': 'A vezetőoldalon, a szélvédőn keresztül látható helyen.',
	'hint.vin.location2': 'A vezetőoldali ajtókereten.',
	'hint.vin.location3': 'A motortérben, gyakran egy fémlapon feltüntetve.',
	'hint.vin.location4': 'Régebbi járműveknél az alváz elülső részén.',
	'overallDashboardImage.title': 'Műszerfal',
	'overallDashboardImage.description':
		'Készítsen egy fotót a műszerfalról, ügyelve arra, hogy minden kezelőszerv és kijelző jól látható legyen.',
	'dashboardMileage.title': 'Kilométeróra',
	'vehicleMileage.description':
		'Készítsen fotót a gépjármű kilométerórájáról úgy, hogy az aktuális óraállás jól látható legyen. Ha digitális kijelzője van, kérjük indítsa be ehhez a járművet.',
	'dashboardMileage.paragraph.first': 'Adja meg a kilométeróra állását!',
	'dashboardMileage.placeholder.updated': 'Kilométeróra állása',
	'review.title': 'Véglegesítés',
	'review.paragraph.first':
		'A befejezés előtt kérjük, ellenőrizze, hogy minden adat helyes-e.<br/><br/>A „Befejezés” gombra kattintást követően ellenőrizzük a feltöltött fényképeket és a megadott adatokat.',
	'review.stepDescription.questions': 'Járműadatok',
	'review.stepDescription.group.perspectiveImages': 'A jármű külső áttekintő fotói',
	'review.stepDescription.group.additionalImages': 'További fényképek',
	'review.stepDescription.vehicleFrontLeftPerspective': 'A gépjármű bal első része átlósan',
	'review.stepDescription.vehicleRearLeftPerspective': 'A gépjármű bal hátsó része átlósan',
	'review.stepDescription.vehicleRearRightPerspective': 'A gépjármű jobb hátsó része átlósan',
	'review.stepDescription.vehicleFrontRightPerspective': 'A gépjármű jobb első része átlósan',
	'review.stepDescription.windshield': 'Szélvédő',
	'review.stepDescription.vinPicture': 'Alvázszám',
	'review.stepDescription.overallDashboard': 'Műszerfal',
	'review.stepDescription.mileage': 'Kilométeróra',
	'thanks.headline.first': 'A szemlefotók beküldése sikeresen megtörtént!',
	'thankYou.message': 'A szemlefotók beküldési folyamata lezárult! Köszönjük szépen!',
	'feedback.title': 'Kérjük, ossza meg velünk véleményét!',
	'feedback.message':
		'Hogyan értékelné a digitális szemle során szerzett tapasztalatait egy 0-tól 5-ig terjedő skálán?',
	'feedback.helpImprove': 'Egyéb észrevételek (opcionális):',
	'feedback.button.send': 'Küldés',
	'feedback.error.maxLength': 'A visszajelzés legfeljebb 500 karakter hosszú lehet.',
	'timeout.headline.first': 'Ez a munkamenet lejárt.',
	'timeout.paragraph.first': ' ',
	'photoUploading.title': 'Feltöltés',
	'photoAnalyzing.title': 'Kiértékelés folyamatban',
	'photoLoading.title': 'Betöltés folyamatban',
	'camera.darkWarning':
		'Nem megfelelőek a fényviszonyok. Kérjük, gondoskodjon jobb fényviszonyokról!',
	'landscapeModeDetected.title': 'Az automatikus elforgatás aktív.',
	'landscapeModeDetected.text':
		'A jobb kamerahasználat érdekében kérjük, kapcsolja ki az automatikus elforgatást az eszközén.',
	'validationContainer.correct': 'A fotó feltöltése sikeres',
	'button.changeImage': 'Új fotó készítése',
	'button.acceptImage': 'Fotó elfogadása',
	'button.acceptMileage': 'A fotó feltöltése sikeres',
	'button.anotherImage': 'Új fotó készítése',
	'invalidFile.size.title': 'Nem megfelelő fotóméret',
	'invalidFile.size.description': 'A feltöltött fénykép mérete túl nagy.',
	'invalidFile.extension.title': 'A fájltípus nem támogatott.',
	'invalidFile.extension.description':
		'A megadott fájltípus nem támogatott. A támogatott fájltípusok: .jpg, .jpeg, .jfif, .heic, .heif, .png és .bmp.',
	'connectionError.title': 'Hálózati kapcsolat hiba.',
	'connectionError.description': 'Hálózati kapcsolat hiba. Kérjük, töltse fel újra a fényképet!',
	'missingPhoto.title': 'Hiányzó fotó',
	'missingPhoto.description':
		'Úgy tűnik, hogy hiányzik egy fotó. Kérjük, adja hozzá a hiányzó fotót a folytatáshoz.',
};

export default messages;
